var mapSubmissionDataToEndpointVariables = function (endpoint, submissionData) {
    var replaceAll = function (string, search, replace) {
        return string.split(search).join(replace);
    };
    if (submissionData) {
        Object.keys(submissionData).forEach(function (item) {
            endpoint = replaceAll(endpoint, "${" + item + "}", ["string", "number"].includes(typeof submissionData[item])
                ? submissionData[item]
                : "${" + item + "}");
        });
    }
    return endpoint;
};
var formatRestApiEndpoint = function (endpoint, queryParameters, submissionData) {
    if (submissionData === void 0) { submissionData = {}; }
    var apiEndpoint = endpoint;
    if (queryParameters) {
        queryParameters.forEach(function (param, index) {
            if (index > 0)
                apiEndpoint = apiEndpoint + "&" + param.queryParameter + "=" + param.value;
            else
                apiEndpoint = apiEndpoint + "?" + param.queryParameter + "=" + param.value;
        });
    }
    return mapSubmissionDataToEndpointVariables(apiEndpoint, submissionData);
};
export default formatRestApiEndpoint;
//# sourceMappingURL=FormatRestApiEndpoint.js.map